import { createStyles, makeStyles } from '@material-ui/styles';
import Excluir from '../icons/icon-img/excluir.png'

export const ExcluirIcon = () => {
  const useStyles = makeStyles(() => 
    createStyles({
      img: {
        margin: '0 10px'
      },
    })
  )
  const classes = useStyles();
  return (
    <>
      <img
      className={classes.img}
      src={Excluir} 
      alt="" 
      />
    </>
  );
};
